{
  "breadcrumbAriaLabel": "வழிசெலுத்தல் பாதை",
  "homeAriaLabel": "முகப்பு",
  "mainNavAriaLabel": "முதன்மை வழிசெலுத்தல்",
  "closeSidebarAriaLabel": "பக்கப்பட்டியை மூடு",
  "collapse": "சுருக்கு",
  "help": "உதவி",
  "settings": "அமைப்புகள்",
  "myProfile": "எனது சுயவிவரம்",
  "groups": {
    "clinical": "மருத்துவம்",
    "worklists": "பணிப் பட்டியல்கள்",
    "documentation": "மருத்துவ ஆவணங்கள்",
    "orders": "ஆணைகள்",
    "medications": "மருந்துகள்",
    "scheduling": "சந்திப்புத் திட்டமிடல்",
    "billing": "கட்டண விவரம்",
    "analytics": "பகுப்பாய்வு",
    "organization": "நிறுவனம்",
    "security": "பாதுகாப்பு",
    "accessReviews": "Access Reviews",
    "integrations": "ஒருங்கிணைப்புகள்",
    "system": "அமைப்பு",
    "licensing": "உரிமம்"
  },
  "dashboard": "முகப்புப் பலகை",
  "patients": "நோயாளர்கள்",
  "patientSearch": "நோயாளர் தேடல்",
  "myPatients": "என் நோயாளர்கள்",
  "censusBedBoard": "உள்நோயாளர்கள் / படுக்கை பலகை",
  "providerDirectory": "மருத்துவர் அடைவு",
  "providerCoverage": "மருத்துவர் பணிநேர ஒதுக்கம்",
  "patientMerge": "நோயாளர் தகவல் ஒன்றிணைப்பு",
  "inbox": "உள்பெட்டி",
  "pendingResults": "நிலுவையிலுள்ள முடிவுகள்",
  "criticalResults": "அவசர முடிவுகள்",
  "unsignedNotes": "கையொப்பமிடப்படாத குறிப்புகள்",
  "cosignQueue": "இணை கையொப்ப வரிசை",
  "noteTemplates": "குறிப்பு வார்ப்புருக்கள்",
  "smartPhrases": "ஸ்மார்ட் சொற்றொடர்கள்",
  "orderCatalog": "ஆணை அட்டவணை",
  "orderSets": "ஆணை தொகுப்புகள்",
  "encounters": "சந்திப்புகள்",
  "orders": "ஆணைகள்",
  "results": "முடிவுகள்",
  "medications": "மருந்துகள்",
  "notes": "குறிப்புகள்",
  "medicationWorklist": "Medication Worklist",
  "formulary": "மருந்துப் பட்டியல்",
  "pharmacistQueue": "மருந்தாளுநர் வரிசை",
  "appointments": "சந்திப்புகள்",
  "scheduleManagement": "திட்ட நிர்வாகம்",
  "waitlist": "காத்திருப்புப் பட்டியல்",
  "charges": "கட்டணங்கள்",
  "claims": "கோரிக்கைகள்",
  "payments": "கட்டணப் பணம்",
  "accounts": "கணக்குகள்",
  "statements": "அறிக்கைகள்",
  "denials": "மறுப்புகள்",
  "analyticsDashboard": "முகப்புப் பலகை",
  "reports": "அறிக்கைகள்",
  "qualityMeasures": "தர அளவுகோல்கள்",
  "healthSystems": "சுகாதார அமைப்புகள்",
  "facilities": "மருத்துவ மையங்கள்",
  "locations": "இடங்கள்",
  "clinicalTaxonomy": "மருத்துவ வகைப்பாடு",
  "serviceLocation": "சேவை ↔ இடம்",
  "providers": "மருத்துவ பணியாளர்கள்",
  "users": "பயனர்கள்",
  "roles": "பாத்திரங்கள்",
  "accessMatrix": "அணுகல் அட்டவணை",
  "integrations": "ஒருங்கிணைப்புகள்",
  "thirdPartyApps": "மூன்றாம் தரப்பு பயன்பாடுகள்",
  "audit": "தணிக்கை",
  "system": "அமைப்பு",
  "cdsRules": "CDS விதிகள்",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "தேடல்",
    "register": "பதிவு",
    "demographics": "அடிப்படை விவரம்",
    "census": "உள்நோயாளர்கள்",
    "discharge": "வீடு திருப்பல்",
    "catalog": "அட்டவணை",
    "sets": "ஆணை தொகுப்புகள்",
    "pending": "நிலுவையில்",
    "critical": "அவசர",
    "reconciliation": "மருந்து ஒப்பீடு",
    "worklist": "பணிப் பட்டியல்",
    "templates": "வார்ப்புருக்கள்",
    "smartPhrases": "ஸ்மார்ட் சொற்றொடர்கள்",
    "schedule": "திட்ட நிர்வாகம்",
    "quality": "தர அளவுகோல்கள்",
    "administration": "நிர்வாகம்",
    "auditLog": "தணிக்கை பதிவு",
    "allergies": "ஒவ்வாமைகள்",
    "problems": "பிரச்னைப் பட்டியல்",
    "immunizations": "தடுப்பூசிகள்",
    "insurance": "காப்பீடு"
  },
  "handoffs": "ஒப்படைப்புகள்",
  "duplicateReview": "நகல் மறுஆய்வு",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "உத்தரவு பணிப்பட்டியல்"
}
